import { RouteConfig, SideLink } from '@/types/utility.types'
import {
  IconPackage,
  IconListCheck,
  IconArrowBackUp,
  IconAlignBoxLeftTop,
} from '@tabler/icons-react'

export const orderModuleKey = 'orders'
export const returnProductModuleKey = 'product_return'
export const salesWindowModuleKey = 'sales_window'

const orderRoute: RouteConfig = {
  uid: orderModuleKey,
  path: 'orders/orders-list',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/orders/orders')).default,
  }),
}

const orderDetailRoute: RouteConfig = {
  uid: orderModuleKey,
  path: 'orders/:id',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/orders/orders/view')).default,
  }),
}

const returnProductRoute: RouteConfig = {
  uid: returnProductModuleKey,
  path: 'orders/return-products',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/orders/product-return')).default,
  }),
}

const createReturnProductRoute: RouteConfig = {
  uid: returnProductModuleKey,
  path: 'orders/return-products/create',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/orders/product-return/create')).default,
  }),
}

const viewReturnProductRoute: RouteConfig = {
  uid: returnProductModuleKey,
  path: 'orders/return-products/view/:id',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/orders/product-return/view')).default,
  }),
}

const salesWindowRoute: RouteConfig = {
  uid: salesWindowModuleKey,
  path: 'orders/sales-window-list',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/orders/sales-window')).default,
  }),
}

const createSalesWindowRoute: RouteConfig = {
  uid: salesWindowModuleKey,
  path: 'orders/sales-window-list/create',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/orders/sales-window/create')).default,
  }),
}

const editSalesWindowRoute: RouteConfig = {
  uid: salesWindowModuleKey,
  path: 'orders/sales-window-list/:id',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/orders/sales-window/edit')).default,
  }),
}

export const sidelink: SideLink = {
  title: 'Orders',
  href: 'orders',
  icon: <IconPackage size={18} />,
  order: 3,
  sub: [
    {
      uid: orderModuleKey,
      title: 'Orders',
      href: 'orders/orders-list',
      icon: <IconListCheck size={18} />,
      order: 1,
    },
    {
      uid: salesWindowModuleKey,
      title: 'Sales window',
      href: 'orders/sales-window-list',
      icon: <IconAlignBoxLeftTop size={18} />,
      order: 2,
    },
    {
      uid: returnProductModuleKey,
      title: 'Return Products',
      href: 'orders/return-products',
      icon: <IconArrowBackUp size={18} />,
      order: 3,
    },
  ],
}

export default [
  orderRoute,
  orderDetailRoute,
  returnProductRoute,
  createReturnProductRoute,
  viewReturnProductRoute,
  salesWindowRoute,
  createSalesWindowRoute,
  editSalesWindowRoute,
]
